// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/**
 * Represents a rotation structure with pitch and yaw
 * components.
 */
export default class PitchYawRotation {
  /**
   * Pitch (up-and-down) element of this rotation.
   */
  "pitch": number;
  /**
   * Yaw component (left-to-right) of this position.
   */
  "yaw": number;
}
